export type WindowOpener = (
  url?: string | URL,
  target?: string,
  features?: string,
) => Window | null;

export function openPrintWindow(
  openWindow: WindowOpener = window.open.bind(window),
) {
  // `noopener` makes window.open return null in modern browsers, which prevents
  // us from writing the invoice into the newly opened same-origin document.
  const printWindow = openWindow("", "_blank", "popup,width=920,height=900");
  if (!printWindow) return null;

  // The document is fully controlled by the CRM, so sever the opener manually
  // while keeping the Window reference required to render and print it.
  printWindow.opener = null;
  return printWindow;
}
